
import { defineComponent, ref, computed } from "vue";
import { IPost } from "../../interfaces/IPost";
import { useRouter } from "vue-router";
import { colorLog } from "../../utils/colorLog";
import { rustAxios } from "../../ajax";
import SectionPost from "./SectionPost.vue";
import { ISection } from "../../interfaces/ISection";
import { ProjectStore } from "../../store/project/project.store";
import { useStore, PROJECT_STORE_SYMBOL } from "../../store";

export default defineComponent({
  components: {
    SectionPost,
  },
  props: {
    section: {
      type: Object as () => ISection,
      required: true,
    },
    projectName: {
      type: String,
      required: true
    },
    categoryName: {
      type: String,
      required: true
    }
  },
  emits: ['update-posts'],
  setup(props, ctx) {
    // colorLog('project section')
    // console.log(props.categoryName);
    const showBody = ref(true)
    
    const typeNames: IPost["type"][] = props.section.posts.map(p => p.type).concat(['all']);

    const selectedType = ref<IPost["type"]>();
    const posts = computed(() =>
      props.section.posts.filter((post) => {
        // console.log(post);
        return selectedType.value ? post.type == selectedType.value : true;
      })
    );
    console.log(posts.value);
    
    const setType = (type: IPost["type"]) => {
      selectedType.value = type == "all" ? "" : type;
    };

    const router = useRouter();
    const message = ref();
    const onRust = async () => {
      colorLog("rust message", 1);
      message.value = await rustAxios("get", "say", { name: "shortpoet" });
    };
    const toPost = () => {
      colorLog("#### to show post ####");
      router.push({
        name: "WaitShowPost",
        // params: { id: props.post.id, title: props.post.title },
      });
    };
    const newPost = () => {
      router.push({ name: 'WaitNewPost', params: { name: props.projectName, category: props.categoryName, section: props.section.name }})
    }
    const projectStore: ProjectStore = useStore<ProjectStore>(PROJECT_STORE_SYMBOL) as ProjectStore

    const updatePosts = async () => {
      colorLog('update posts')
      await projectStore.deleteSection(props.section)
      ctx.emit('update-posts')
    }

    return {
      showBody,
      onRust,
      message,
      toPost,
      setType,
      typeNames,
      selectedType,
      posts,
      newPost,
      updatePosts
    };
  },
});
